import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import bannerRobot from '../assets/images/banner-robot.png';
import commentIcon1 from '../assets/images/coment-box-icon1.png';
import commentIcon2 from '../assets/images/coment-box-icon2.png';
import dropdownImage from '../assets/images/banner-dropdownimage.png';

const Banner = () => {
    const { t } = useTranslation();

    return (
        <section className="float-left w-100 banner-con position-relative main-box">
            <Container>
                <Row className="align-items-center">
                    <Col lg={7} md={7}>
                        <div className="banner-content-con">
                            <ul className="list-unstyled p-0">
                                <li className="position-relative d-inline-block">
                                    <FontAwesomeIcon icon={faCircleCheck} /> {t('banner_trial_info1')}
                                </li>
                                <li className="position-relative d-inline-block">
                                    <FontAwesomeIcon icon={faCircleCheck} /> {t('banner_trial_info2')}
                                </li>
                            </ul>
                            <h1>
                                {t('banner_title').split('Chatbot')[0]}
                                <span className="d-inline-block font-weight-bold color-blue">Chatbot</span>
                                {t('banner_title').split('Chatbot')[1]}
                            </h1>
                            <p>{t('banner_subtitle')}</p>
                            <a href="/about" className="text-decoration-none primary_btn d-inline-block">
                                {t('banner_get_started')}
                            </a>
                            <a href="/contact" className="text-decoration-none secondary_btn d-inline-block">
                                {t('banner_live_demo')}
                            </a>
                        </div>
                    </Col>
                    <Col lg={5} md={5}>
                        <div className="banner-img-con position-relative">
                            <figure>
                                <img src={bannerRobot} alt="robot" className="animated-robot" />
                            </figure>
                            <div className="coment-box1 d-flex align-items-center popup-bubble popup-delay-1">
                                <img src={commentIcon1} alt="icon" className="img-fluid" />
                                <p className="typing mb-0" id="text1"></p>
                            </div>
                            <div className="coment-box2 d-flex align-items-center popup-bubble popup-delay-2">
                                <img src={commentIcon2} alt="icon" className="img-fluid" />
                                <p className="typing mb-0" id="text2"></p>
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className="down_button text-center d-inline-block">
                    <a href="#client" className="scroll text-decoration-none">
                        <figure className="banner-dropdownimage mb-0 d-inline-block">
                            <img src={dropdownImage} className="img-fluid" alt="image" />
                        </figure>
                    </a>
                </div>
            </Container>
        </section>
    );
};

export default Banner;